export default "__VITE_ASSET__BC2bCZQ4__"